import { Button, IconButton, Tooltip, Box } from "@mui/material";
import React, { useMemo, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { EditOutlined } from "@mui/icons-material";
import { useGlobalFilter, useSortBy, useTable } from "react-table";
import { GlobalFilter } from "../../components/GlobalFilter/GlobalFilter";
import { useLists } from "../../context/listContext";
import { AntSwitch } from "../../styles/index.sty";
import { useAuth } from "../../context/authContext";
import { toggleSliderData } from "../../api/slider.api";
import InsertPhotoIcon from "@mui/icons-material/InsertPhoto";
import PuffLoader from "react-spinners/PuffLoader";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

export const Slider = () => {
  const navigate = useNavigate();
  const { config } = useAuth();
  const { sliderList, fetchSlidersList } = useLists();
  const data = useMemo(() => sliderList, [sliderList]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSlidersList();
  }, []);

  useEffect(() => {
    if (sliderList.length > 0) {
      setLoading(false);
    }
  }, [sliderList]);

  const columns = useMemo(
    () => [
      {
        Header: "Slider Name",
        accessor: "slider_name",
      },
      {
        Header: "Slider Type",
        accessor: "slider_type",
      },
      {
        Header: "Sub heading",
        accessor: "slider_sub_heading",
      },
      {
        Header: "Argument",
        accessor: "argument",
      },
    ],
    []
  );

  const tableHooks = (hooks) => {
    hooks.visibleColumns.push((columns) => [
      ...columns,
      {
        id: "ACTIONS",
        Header: "Actions",
        Cell: ({ row }) => {
          return (
            <div className="flex justify-center">
              <Tooltip
                title="Add Image"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/add-slider-images", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <InsertPhotoIcon
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title="edit"
                onClick={() => {
                  // console.log(row.id)
                  navigate("/update-slider", {
                    state: {
                      data: row.original,
                    },
                  });
                }}
              >
                <IconButton>
                  <EditOutlined
                    style={{ fontSize: "2rem", color: "#0a305e" }}
                  />
                </IconButton>
              </Tooltip>
              <Tooltip
                title={`${row.is_active ? "active" : "in-active"}`}
                onClick={() =>
                  toggleSliderData(
                    { slider_id: row.original.slider_id },
                    config,
                    fetchSlidersList
                  )
                }
              >
                <IconButton>
                  {" "}
                  <AntSwitch
                    checked={row.original.is_active ? true : false}
                    inputProps={{ "aria-label": "ant design" }}
                  />
                </IconButton>
              </Tooltip>
            </div>
          );
        },
      },
    ]);
  };

  const tableInstance = useTable(
    { columns, data },
    useGlobalFilter,
    tableHooks,
    useSortBy
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    preGlobalFilteredRows,
    setGlobalFilter,
    state,
  } = tableInstance;

  return (
    <>
      {loading ? (
        <Box sx={style}>
          <PuffLoader loading={loading} size={150} />
        </Box>
      ) : (
        <>
          <div className="flex justify-between w-[95%] m-auto mt-[5rem]">
            <GlobalFilter
              preGlobalFilteredRows={preGlobalFilteredRows}
              setGlobalFilter={setGlobalFilter}
              globalFilter={state.globalFilter}
            />
            <Button
              type="button"
              variant="contained"
              // onClick={handleOpen}
              onClick={() => navigate("/add-slider")}
            >
              Add New
            </Button>
          </div>
          <table {...getTableProps()} className="w-[95%] m-auto mt-10">
            <thead>
              {
                // Loop over the header rows
                headerGroups.map((headerGroup) => (
                  // Apply the header row props
                  <tr {...headerGroup.getHeaderGroupProps()}>
                    {
                      // Loop over the headers in each row
                      headerGroup.headers.map((column) => (
                        // Apply the header cell props
                        <th
                          {...column.getHeaderProps()}
                          className="border-4 p-3 bg-[#1976d2] text-white"
                        >
                          {
                            // Render the header
                            column.render("Header")
                          }
                        </th>
                      ))
                    }
                  </tr>
                ))
              }
            </thead>
            {/* Apply the table body props */}
            <tbody {...getTableBodyProps()}>
              {
                // Loop over the table rows
                rows.map((row, index) => {
                  // Prepare the row for display
                  prepareRow(row);
                  return (
                    // Apply the row props
                    <tr {...row.getRowProps()}>
                      {
                        // Loop over the rows cells
                        row.cells.map((cell) => {
                          // Apply the cell props
                          return (
                            //  <td {...cell.getCellProps()} className={`p-5 border-1px bg-blue-300 cursor-pointer`}>
                            <td
                              {...cell.getCellProps()}
                              className={`p-5 border-1px bg-${
                                index % 2 === 0 ? "white" : "blue-300"
                              } cursor-pointer text-center`}
                              style={{
                                background: !row.original.is_active
                                  ? "#b3b3b3"
                                  : null,
                              }}
                            >
                              {
                                // Render the cell contents
                                cell.render("Cell")
                              }
                            </td>
                          );
                        })
                      }
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </>
      )}
    </>
  );
};
